<div class="mep-dialog-header-icon">
	<mat-icon> settings </mat-icon>
</div>
<div class="mep-dialog-title">{{ _lang("title") }}</div>
<mat-progress-bar [class.invisible]="!loading" mode="indeterminate"></mat-progress-bar>

<div class="full-height-dialog-content mep-dialog-content" mat-dialog-content>
	<app-employee-drag-drop-list
		[employeesRight]="employeesWithAccess"
		[projectLeader]="data.projectLeader"
	></app-employee-drag-drop-list>
</div>

<div class="mep-dialog-actions">
	<button (click)="closeDialog()" class="mep-btn-dialog-secondary">
		{{ _lang("cancel") }}
	</button>
	<button (click)="saveEmployeeAccess()" [disabled]="this.loading" class="mep-btn-dialog-primary">
		{{ _lang("save") }}
	</button>
</div>
